// Configuration file for app settings

export const config = {
    // Google Calendar appointment scheduling page URL (for opening in new tab)
    calendarUrl: 'https://calendar.app.google/UN19YMUjB48tE5oNA',
    
    // Google Calendar embed URL (for iframe embedding)
    calendarEmbedUrl: 'https://calendar.google.com/calendar/appointments/schedules/AcZssZ3TuWWab1oq3WiXU5guLitM2BXqhJBq3hQBeSBGiz2Be2_tjrWYbivdgVnbBdqoCuSq3Fd051i2?gv=true',
    
    // Contact email
    contactEmail: 'contact@devcraft.co.in',
    
    // Website URL
    websiteUrl: 'www.devcraft.co.in',
    siteOrigin: 'https://www.devcraft.co.in',

    // MGenie mail API (static site calls this directly; no backend secret)
    mailApiBaseUrl: (process.env.REACT_APP_MGENIE_MAIL_BASE_URL || 'https://mgenie.devcraft.co.in').replace(/\/$/, ''),
};

